<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" search :data="masters">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">Add</vs-button>
        
        <vs-button radius color="primary" type="gradient" class="mr-4 mb-4">. {{ masters.length }} .</vs-button>
      </div>

      <template slot="thead">
        <vs-th sort-key="username">User Name</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="group.libelle">Rôle</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.username }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.email }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.group.libelle }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <!-- <vx-tooltip text="Detail" color="primary">
                  <feather-icon
                    style="color: #FF8000"
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                    @click="see(tr)"
                  />
                </vx-tooltip> -->
                <vx-tooltip text="Update" color="warning">
                  <feather-icon
                    style="color: #FF9F43"
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-warning stroke-current"
                    class="mr-2"
                    @click="edit(tr)"
                  />
                </vx-tooltip>
                <vx-tooltip text="Delete" color="danger">
                  <feather-icon
                    @click="groups_delete(tr.id)"
                    style="color: red"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>

              </div>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div>
      <vs-pagination class="items-center" :total="total" v-model="currentx"></vs-pagination>
    </div>
    <template slot="footer">
      <vs-pagination class="items-center" :total="total" v-model="currentx"></vs-pagination>
    </template>
  </div>
</template>

<script>
let base_self = ''
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataList from '@/store/data-list/moduleDataList.js'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      currentx: 1,
      total: 2,
      selected: [],
      masters: [],
      itemsPerMaster: 5000,
      isMounted: false,

      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentMaster () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },
  methods: {
    see (data) {
      base_self.sidebarData = JSON.parse(JSON.stringify(data))
      base_self.sidebarData.detail__detail = true
      base_self.toggleDataSidebar(true)
    },
    edit (data) {
      base_self.sidebarData = JSON.parse(JSON.stringify(data))
      base_self.toggleDataSidebar(true)
    },
    async groups_delete (id) {
      
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_deletion'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          const params = {
            id
          }

          base_self.$http.delete(`${base_self.$store.state.route_for_account}groups`, { params })
            .then((response) => {
              window.getESM.success('The groups is deleted successfully.', response)
              base_self.getMasters()
            })
            .catch(() => {
              window.getESM.error({ message: 'Master removal failed.' })
            })
        }
      })
    },
    async getMasters () {
      base_self.$http.get(`${base_self.$store.state.route_for_esm}users/list`)
        .then((response) => {
          console.log('response: ', response)
          base_self.masters = response.data.users
          base_self.total = Math.ceil(Number(response.data.users.length) / base_self.itemsPerMaster)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 'admin') return 'warning'
      if (status === 'director') return 'primary'
      if (status === 'manager') return 'success'
      if (status === 'agronomist') return 'danger'
      return 'dark'
    },
    getPopularityColor (num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  },
  created () {
    window.getAppMasters = this
    base_self = this
    base_self.getMasters()

    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('dataList/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
